<onsip-loading-container [deferCond]="isDataObtained$">
  @if (hasExternalAddress$ | async) {
  <onsip-header-main>
    <onsip-header-action-bar>
      <mat-form-field appearance="outline">
        <input
          matInput
          [formControl]="search"
          [placeholder]="'Search'"
          [attr.data-cy]="E2eLocators.ADMIN_EXT_SIP_SEARCH"
          autocomplete="off"
        />
        <mat-icon color="primary" matSuffix>search</mat-icon>
      </mat-form-field>
      <a
        mat-stroked-button
        onsip-header-secondary-action
        color="primary"
        class="att_menu-add"
        type="button"
        [attr.data-cy]="E2eLocators.ADMIN_EXT_SIP_ADD_BTN"
        [routerLink]="views.ADMIN_EXTERNAL_ADDRESS_SETUP"
      >
        {{ "ONSIP_I18N.ADD_EXTERNAL_SIP_ADDRESS" | translate }}
      </a>
    </onsip-header-action-bar>
  </onsip-header-main>
  <onsip-table-two
    class="external-address-table"
    matSort
    multiTemplateDataRows
    [trackBy]="trackByAddressId"
    [dataSource]="dataSource"
    [useGrid]="true"
    [hoverable]="true"
  >
    <!-- menu name-->
    <ng-container matColumnDef="name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Address Name</mat-header-cell>
      <mat-cell *matCellDef="let address">
        <span class="text-ellipsis">
          {{ address.name }}
        </span>
      </mat-cell>
    </ng-container>
    <!-- extensions -->
    <ng-container matColumnDef="extensions">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Extensions</mat-header-cell>
      <mat-cell *matCellDef="let address">
        <span class="extension-column">{{
          (address?.extensions | formatExtensions).join(", ")
        }}</span>
      </mat-cell>
    </ng-container>
    <!-- destination -->
    <ng-container matColumnDef="address">
      <mat-header-cell *matHeaderCellDef mat-sort-header>External Address</mat-header-cell>
      <mat-cell *matCellDef="let address">
        <span class="text-ellipsis">
          {{ address.foreignAddress }}
        </span>
      </mat-cell>
    </ng-container>
    <!-- Action Column -->
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let address">
        <div class="controls-wrapper">
          @if (selectedRows.includes(address.addressId)) {
          <mat-icon color="primary">expand_less </mat-icon>
          } @if (!selectedRows.includes(address.addressId)) {
          <mat-icon color="primary">expand_more </mat-icon>
          }
          <button
            [attr.data-cy]="E2eLocators.ADMIN_EXT_SIP_REMOVE_BTN"
            mat-icon-button
            (click)="removeItem(address, $event)"
          >
            <mat-icon color="primary">delete</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>
    <!-- Expanded Shelf -->
    <ng-container matColumnDef="expanded">
      <onsip-table-shelf-cell
        *matCellDef="let address"
        [attr.colspan]="displayedColumns.length"
        [expanded]="selectedRows.includes(address.addressId)"
      >
        @if (selectedRows.includes(address.addressId)) { @if ((isEditMode$ | async) === false) {
        <onsip-external-sip-address-shelf-view
          [externalSip]="address"
          (startEditing)="isEditMode$.next(true)"
        >
        </onsip-external-sip-address-shelf-view>
        } @if (isEditMode$ | async) {
        <onsip-external-sip-address-shelf-edit
          [externalSip]="address"
          (cancelEditing)="isEditMode$.next(false)"
        >
        </onsip-external-sip-address-shelf-edit>
        } }
      </onsip-table-shelf-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: displayedColumns"
      [attr.data-cy]="E2eLocators.ADMIN_EXT_SIP_ROW"
      (click)="
        selectedRows.includes(row.addressId)
          ? selectedRows.splice(selectedRows.indexOf(row.addressId), 1)
          : selectedRows.push(row.addressId);
        isEditMode$.next(false)
      "
    >
    </mat-row>
    <onsip-table-shelf *matRowDef="let row; columns: ['expanded']"></onsip-table-shelf>
    <div *matNoDataRow class="no-data-row">
      @if (search.value && dataSource.data.length) {
      <span>
        {{ "ONSIP_I18N.NO_RESULTS" | translate }}
      </span>
      }
    </div>
  </onsip-table-two>
  <mat-paginator
    onsip-paginator-primary-icon
    showFirstLastButtons
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
  >
  </mat-paginator>
  } @else {
  <div class="empty-state">
    <div class="mat-headline-4 setup-title">
      {{ "ONSIP_I18N.ADD_AN_EXTERNAL_SIP_ADDRESS" | translate }}
    </div>
    <div class="mat-body-2 setup-text">
      {{ "ONSIP_I18N.ROUTE_CALLS_BETWEEN_ONSIP_AND_AN_EXTERNAL_VOIP_PROVIDER" | translate }}
    </div>
    <a
      mat-flat-button
      color="primary"
      class="att_menu-setup-box"
      type="button"
      [attr.data-cy]="E2eLocators.ADMIN_EXT_SIP_ADD_BTN"
      [routerLink]="views.ADMIN_EXTERNAL_ADDRESS_SETUP"
    >
      <span translate [translateParams]="{ value: 'external SIP address' }">
        ONSIP_I18N.SET_UP_VALUE
      </span>
    </a>
    <div class="pricing-text">
      {{ "ONSIP_I18N.PRICING" | translate }}: {{ "ONSIP_I18N.FREE" | translate }}
    </div>
  </div>
  }
</onsip-loading-container>
